import { render, staticRenderFns } from "./editProviderHotGame.vue?vue&type=template&id=a8324c3e&lang=pug"
import script from "./editProviderHotGame.vue?vue&type=script&lang=js"
export * from "./editProviderHotGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports